module.exports = __webpack_public_path__ + "img/agents_deductions_fr-be.fef44a97.svg";